import React from 'react';
import { Section, Container } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { isValidTitle } from 'utils/validateTitle';

import loadable from '@loadable/component';
const SmallTitleTextVideo = loadable(() =>
  import('components/components/molecules/SmallTitleTextVideo'),
);
const SmallTitleTextVideoContainer = ({ fields, rendering }) => {
  const title = getFieldValue(fields, 'title');
  const text = getFieldValue(fields, 'text');

  if (!isValidTitle(title) && !text) {
    return null;
  }

  return (
    <Section>
      <Container>
        <SmallTitleTextVideo fields={fields} />
      </Container>
    </Section>
  );
};

export default SmallTitleTextVideoContainer;
